import './registrationDetailsHit'
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import React, { useState, useEffect } from "react";
import { GET_ADDRESS_BY_PINCODE, UPLOAD_DCUMENT, authKey, ResourceUpdateMember } from '../../../../common/URLs';
import { ROLES, ADD_POPOVER, API_DATE_FORMAT, BASIC_DATE_FORMAT, CANCEL_POPOVER, DATE_RANGE_ERROR, DRIVING_LICENSE, EMPTY_FIELD_ERROR, GENDER, LOI_ABRPL_AGREEMENT, MOBILE_NO_ERROR, NUMBER_OF_MONTH, PINCODE_NO_ERROR, UPDATE_POPOVER, UPLOAD_FILE_TEXT } from '../../../../common/constants';
import moment from 'moment';
import { Button, RadioGroup, Radio, Container, Divider, Card, CardContent, ToggleButton, ToggleButtonGroup, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, FormLabel } from '@mui/material';
// import { Col, Container, Row, Stack } from 'react-bootstrap';
import { maxNameLength, mobileNumberValidation, nameValidation, pincodeValidation, VALIDATION } from '../../../../common/commonValidations';
import { FileUpload } from "../../../../common/fileUpload/fileUpload";
import { PROD } from '../../../../common/constants';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { FileUploadMUI } from '../../../../common/fileUpload/fileUploadMUI';
import { v4 as uuidv4 } from 'uuid';
import { subYears } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { handleNumberFieldFocus } from '../../../../common/commonFunction';

export const DriverPopupHit = (props) => {
    const {t} = useTranslation();
    const [harvesterOrDriver, setHarvesterOrDriver] = useState(props?.harvesterOrDriver ? props?.harvesterOrDriver : "Driver");
    const [documentsArray, setDocumentsArray] = useState(props.harvestOrDriverItem ? props.harvestOrDriverItem.documents : []);
    const [harvesterDetail, setHarvesterDetail] = useState(
        {
            id: props.harvestOrDriverItem ? props.harvestOrDriverItem.id : uuidv4(),
            regHitMasterId: props?.regStakeholderMaster?.id,
            harvesterName: props.harvestOrDriverItem ? props.harvestOrDriverItem.harvesterName : null,
            harvesterDob: props.harvestOrDriverItem ? props.harvestOrDriverItem.harvesterDob : moment(subYears(new Date(), 18)).format(API_DATE_FORMAT),
            harvesterGender: props.harvestOrDriverItem ? props.harvestOrDriverItem.harvesterGender : 'Male',
            harvesterContactNo: props.harvestOrDriverItem ? props.harvestOrDriverItem.harvesterContactNo : null,
            harvesterAddress: props.harvestOrDriverItem ? props.harvestOrDriverItem.harvesterAddress : null,
            harvesterPincode: props.harvestOrDriverItem ? props.harvestOrDriverItem.harvesterPincode : null,
            agreementStartDate: props.harvestOrDriverItem ? props.harvestOrDriverItem.agreementStartDate : null,
            agreementEndDate: props.harvestOrDriverItem ? props.harvestOrDriverItem.agreementEndDate : null,
            isTrainingCompleted: props.harvestOrDriverItem ? props.harvestOrDriverItem.isTrainingCompleted : true,
            isActive: 1,
            createdOn: props.harvestOrDriverItem ? props.harvestOrDriverItem.createdOn : null,
            createdBy: props.harvestOrDriverItem ? props.harvestOrDriverItem.createdBy : null,
            updatedOn: props.harvestOrDriverItem ? props.harvestOrDriverItem.updatedOn : null,
            updatedBy: props.harvestOrDriverItem ? props.harvestOrDriverItem.updatedBy : null,
            documents: documentsArray
        }
    );
    const [driverDetail, setDriverDetail] = useState(
        {
            id: props.harvestOrDriverItem ? props.harvestOrDriverItem.id : uuidv4(),
            regHitMasterId: props?.regStakeholderMaster?.id,
            driverName: props.harvestOrDriverItem ? props.harvestOrDriverItem.driverName : null,
            driverDob: props.harvestOrDriverItem ? props.harvestOrDriverItem.driverDob : moment(subYears(new Date(), 18)).format(API_DATE_FORMAT),
            driverGender: props.harvestOrDriverItem ? props.harvestOrDriverItem.driverGender : 'Male',
            driverContactNo: props.harvestOrDriverItem ? props.harvestOrDriverItem.driverContactNo : null,
            driverAddress: props.harvestOrDriverItem ? props.harvestOrDriverItem.driverAddress : null,
            driverPincode: props.harvestOrDriverItem ? props.harvestOrDriverItem.driverPincode : null,
            yearsOfExp: props.harvestOrDriverItem ? props.harvestOrDriverItem.yearsOfExp : null,
            driverType: props.harvestOrDriverItem ? props.harvestOrDriverItem.driverType : null,
            driverLicenseId: props.harvestOrDriverItem ? props.harvestOrDriverItem.driverLicenseId : null,
            licenceIssueDate: props.harvestOrDriverItem ? props.harvestOrDriverItem.licenceIssueDate : moment(new Date()).format(API_DATE_FORMAT),
            licenceValidityEnddate: props.harvestOrDriverItem ? props.harvestOrDriverItem.licenceValidityEnddate : moment(new Date()).format(API_DATE_FORMAT),
            isActive: 1,
            createdOn: props.harvestOrDriverItem ? props.harvestOrDriverItem.createdOn : null,
            createdBy: props.harvestOrDriverItem ? props.harvestOrDriverItem.createdBy : null,
            updatedOn: props.harvestOrDriverItem ? props.harvestOrDriverItem.updatedOn : null,
            updatedBy: props.harvestOrDriverItem ? props.harvestOrDriverItem.updatedBy : null,
            documents: documentsArray
        }
    );
    const [errorMessage, setErrorMessage] = useState({
        fullNameError: '',
        driverDobError: '',
        mobileNoError: '',
        addressError: '',
        drivingLicenseError: '',
        pincodeError: '',
        endDateError: '',
        harvesterNameError: '',
        harvesterContactError: '',
        harvesterPincodeError: '',
        harvesterAddressError: '',
        harvesterDobError: '',
        documentError: '',
        trainingCertificateDocError: '',
        dirivingLicenseError: ''

    });
    const [drivingExpInYrs, setDrivingExpInYrs] = useState(driverDetail.yearsOfExp ? driverDetail.yearsOfExp.toString().split(".")[0] : 0);
    const [drivingExpInMonths, setDrivingExpInMonths] = useState(driverDetail.yearsOfExp ? driverDetail.yearsOfExp.toString().split(".")[1] : 0);
    let userRole = localStorage.getItem('role');
    useEffect(() => {
        if (documentsArray) {
            { harvesterOrDriver === "Harvester" ? setHarvesterDetail({ ...harvesterDetail, documents: documentsArray }) : setDriverDetail({ ...driverDetail, documents: documentsArray }) }

        }
    }, [documentsArray]);

    useEffect(() => {
        if (drivingExpInMonths || drivingExpInYrs) {
            let concatenateValue = parseFloat(drivingExpInYrs + '.' + drivingExpInMonths)
            setDriverDetail({ ...driverDetail, ['yearsOfExp']: concatenateValue });
        }
    }, [drivingExpInMonths, drivingExpInYrs]);
    const onUploadCallBack = (docArray) => {
        setDocumentsArray(docArray);
    }
    const handleHarvesterChange = (e) => {
        setHarvesterDetail({ ...harvesterDetail, [e.target.name]: e.target.value });
        if (e.target.name === 'harvesterName') {
            setHarvesterDetail({ ...harvesterDetail, [e.target.name]: VALIDATION.fullNameValidation(e.target.value) });
            if ((e.target.value.toString())?.length > 0) {
                setHarvesterDetail({ ...harvesterDetail, [e.target.name]: VALIDATION.fullNameValidation(e.target.value) });
                setErrorMessage({ ...errorMessage, harvesterNameError: '' })
            } else setErrorMessage({ ...errorMessage, harvesterNameError: "Please enter Harvester Name" })
        }
        if (e.target.name === 'harvesterContactNo') {
            setHarvesterDetail({ ...harvesterDetail, [e.target.name]: mobileNumberValidation(e.target.value) });
            if ((e.target.value.toString())?.length >= 10) {
                if (props.addOrEdit === "edit" && props?.regStakeholderMaster?.hitHarvesterDetails.filter(item => (item.harvesterContactNo == (e.target.value))).length == 0) {
                    setErrorMessage({ ...errorMessage, harvesterContactError: '' })
                }
                else if (props.addOrEdit === "add")
                    setErrorMessage({ ...errorMessage, harvesterContactError: '' })
                else setErrorMessage({ ...errorMessage, harvesterContactError: "Contact No already exists." })
            } else setErrorMessage({ ...errorMessage, harvesterContactError: "Please enter Mobile No." })
        }
        if (e.target.name === 'harvesterPincode') {
            setHarvesterDetail({ ...harvesterDetail, [e.target.name]: mobileNumberValidation(e.target.value) });
            if ((e.target.value.toString())?.length >= 6) {
                setHarvesterDetail({ ...harvesterDetail, [e.target.name]: pincodeValidation(e.target.value) });
                setErrorMessage({ ...errorMessage, harvesterPincodeError: '' })
            } else setErrorMessage({ ...errorMessage, harvesterPincodeError: "Please enter valid Pincode" })
        }
        if (e.target.name === 'harvesterAddress') {
            setHarvesterDetail({ ...harvesterDetail, [e.target.name]: e.target.value });
            if ((e.target.value.toString())?.length > 0) {
                setHarvesterDetail({ ...harvesterDetail, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value) });
                setErrorMessage({ ...errorMessage, harvesterAddressError: '' })
            } else setErrorMessage({ ...errorMessage, harvesterAddressError: "Please enter Address" })
        }
    };
    const handleDriverChange = (e) => {
        setDriverDetail({ ...driverDetail, [e.target.name]: e.target.value });
        if (e.target.name === 'driverName') {
            setDriverDetail({ ...driverDetail, [e.target.name]: VALIDATION.fullNameValidation(e.target.value) });
            if ((e.target.value.toString())?.length > 0) {
                setDriverDetail({ ...driverDetail, [e.target.name]: VALIDATION.fullNameValidation(e.target.value) });
                setErrorMessage({ ...errorMessage, fullNameError: '' })
            } else setErrorMessage({ ...errorMessage, fullNameError: "Please enter Driver Name" })
        }
        if (e.target.name === 'driverContactNo') {
            setDriverDetail({ ...driverDetail, driverContactNo: mobileNumberValidation(e.target.value) });
            if ((e.target.value.toString())?.length >= 10) {
                if (props.addOrEdit === "edit" && props?.regStakeholderMaster?.hitDriverDetails.filter(item => (item.driverContactNo == (e.target.value))).length == 0) {
                    setErrorMessage({ ...errorMessage, mobileNoError: '' })
                }
                else if (props.addOrEdit === "add")
                    setErrorMessage({ ...errorMessage, mobileNoError: '' })
                else setErrorMessage({ ...errorMessage, mobileNoError: "Contact No already exists." })
            } else setErrorMessage({ ...errorMessage, mobileNoError: "Please enter Mobile No." })
        }
        if (e.target.name === 'driverAddress') {
            if ((e.target.value.toString())?.length > 0) {
                setDriverDetail({ ...driverDetail, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value) })
                setErrorMessage({ ...errorMessage, addressError: '' })
            } else setErrorMessage({ ...errorMessage, addressError: "Please enter Address" })
        }
        if (e.target.name === 'driverLicenseId') {
            if ((e.target.value.toString())?.length > 0) {
                setDriverDetail({ ...driverDetail, [e.target.name]: (e.target.value.toUpperCase()) })
                setErrorMessage({ ...errorMessage, drivingLicenseError: '' })
            } else setErrorMessage({ ...errorMessage, drivingLicenseError: "Please enter valid Driver License ID" })
        }
        if (e.target.name === 'driverPincode') {
            setDriverDetail({ ...driverDetail, [e.target.name]: pincodeValidation(e.target.value) });
            if ((e.target.value.toString())?.length >= 6) {
                setErrorMessage({ ...errorMessage, pincodeError: '' })
            } else setErrorMessage({ ...errorMessage, pincodeError: "Please enter valid Pincode" })
        }
    };
    const radioChange = (e, value) => {
        setHarvesterDetail({ ...harvesterDetail, [e.target.name]: value })
    };
    const handleDateChange = (e, name) => {
        setDriverDetail({ ...driverDetail, [name]: e.format(API_DATE_FORMAT) })
    }
    const handleDriverDobChange = (e) => {
            setDriverDetail({ ...driverDetail, driverDob: e.format(API_DATE_FORMAT) });
            setErrorMessage({ ...errorMessage, driverDobError: "" })
    }
    const handleHarvesterDobChange = (e) => {
        setHarvesterDetail({ ...harvesterDetail, harvesterDob: e.format(API_DATE_FORMAT) });
        setErrorMessage({ ...errorMessage, harvesterDobError: "" })
}
    const onChangeDrivingExpInMonth = (e) => {
        e.preventDefault();
        setDrivingExpInMonths(e.target.value)
        setErrorMessage({ ...errorMessage, experienceError: '' })
    }
    const onChangeDrivingExpInYrs = (e) => {
        e.preventDefault();
        setDrivingExpInYrs(e.target.value)
        setErrorMessage({ ...errorMessage, experienceError: '' })
    }
    const onCheckValidation = () => {
        var drivingLicense = driverDetail?.documents && driverDetail?.documents.filter((item) => item.documentType === "DrivingLicense" && (item.isActive == 1 || item.isActive == 3));
        if (!driverDetail.driverName || driverDetail.driverName?.length == 0) {
            setErrorMessage({ ...errorMessage, fullNameError: "Please enter Driver Name" })
            return;
        }
        else if (!driverDetail.driverDob) {
            setErrorMessage({ ...errorMessage, driverDobError: "Please enter driver date of birth" })
            return;
        }
        else if (!driverDetail.driverContactNo || driverDetail.driverContactNo?.length !== 10) {
            setErrorMessage({ ...errorMessage, mobileNoError: "Please enter Contact No." })
            return;
        }
        else if (props.addOrEdit === "edit" && errorMessage.mobileNoError?.length > 0) {
            setErrorMessage({ ...errorMessage, mobileNoError: "Contact No already exists." })
            return;
        }
        else if (props.addOrEdit === "add" && props?.regStakeholderMaster?.hitDriverDetails.filter(item => (item.driverContactNo === driverDetail.driverContactNo)).length > 0) {
            setErrorMessage({ ...errorMessage, mobileNoError: "Contact No already exists." })
            return;
        }
        else if (!driverDetail.driverPincode || driverDetail.driverPincode?.length !== 6) {
            setErrorMessage({ ...errorMessage, pincodeError: "Please enter valid Pincode" })
            return;
        }
        else if (!driverDetail.driverAddress || driverDetail.driverAddress?.length == 0) {
            setErrorMessage({ ...errorMessage, addressError: "Please enter Address" })
            return;
        }
        else if (!driverDetail.driverLicenseId || driverDetail.driverLicenseId?.length == 0) {
            setErrorMessage({ ...errorMessage, drivingLicenseError: "Please enter valid Driver License ID" })
            return;
        }
       else if (drivingLicense?.length == 0) {
            setErrorMessage({ drivingLicenseError: "Please upload driving license" });
            return;
        }
       
        // else if (!drivingExpInMonths && !drivingExpInYrs) {
        //     setErrorMessage({ ...errorMessage, experienceError: "Please add Experience" })
        //     return;
        // }
      
        else {
            props.driverSubmitCallbackFunction(driverDetail, props.onClose, props.addOrEdit)
        }

    }
    const onCheckValidationHarvester = () => {
        if (!harvesterDetail.harvesterName || harvesterDetail.harvesterName?.length == 0) {
            setErrorMessage({ ...errorMessage, harvesterNameError: "Please enter Harvester Name" })
            return;
        }
        else if (!harvesterDetail.harvesterDob) {
            setErrorMessage({ ...errorMessage, harvesterDobError: "Please enter Harvester date of birth" })
            return;
        }
        else if (!harvesterDetail.harvesterContactNo || harvesterDetail.harvesterContactNo?.length !== 10) {
            setErrorMessage({ ...errorMessage, harvesterContactError: "Please enter valid contact no." })
            return;
        }
        else if (!harvesterDetail.harvesterPincode || harvesterDetail.harvesterPincode?.length !== 6) {
            setErrorMessage({ ...errorMessage, harvesterPincodeError: "Please enter valid pincode" })
            return;
        }
        else if (!harvesterDetail.harvesterAddress || harvesterDetail.harvesterAddress?.length == 0) {
            setErrorMessage({ ...errorMessage, harvesterAddressError: "Please enter address" })
            return;
        }     
        else if (props.addOrEdit === "edit" && errorMessage.harvesterContactError?.length > 0) {
            setErrorMessage({ ...errorMessage, harvesterContactError: "Contact No already exists." })
            return;
        }
        else if (props.addOrEdit === "add" && props?.regStakeholderMaster?.hitHarvesterDetails.filter(item => (item.harvesterContactNo === harvesterDetail.harvesterContactNo))?.length > 0) {
            setErrorMessage({ ...errorMessage, harvesterContactError: "Contact No already exists." })
            return;
        }
        var traningCert = harvesterDetail?.documents && harvesterDetail?.documents.filter((item) => item.documentType === "Harvester_Training_Certificate" && (item.isActive == 1 || item.isActive == 3));
        if (traningCert?.length == 0 && harvesterDetail.isTrainingCompleted == true) {
            setErrorMessage({ trainingCertificateDocError: "Please upload training certificate" });
            return;
        }
        else {
            props.harvesterSubmitCallbackFunction(harvesterDetail, props.onClose, props.addOrEdit)
        }
    }

    return (
        <>
            <Container maxWidth="xxl" >
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG24</p>}
                <Typography variant="h5" gutterBottom>
                    {t('reg.manpowerDetails')}
                </Typography>
                <Grid container spacing={2} direction="row" mt={1}>
                    <Grid item xs={12} lg={6}>
                        <FormControl fullWidth>
                            <InputLabel>{t('reg.type')}</InputLabel>
                            <Select label="Type" value={harvesterOrDriver} onChange={(e) => setHarvesterOrDriver(e.target.value)} disabled={((props.addOrEdit === 'add') || (userRole === 'Reg-ITAdmin')) ? false : true}>
                                <MenuItem value='Driver'>{t('reg.driver')}</MenuItem>
                                <MenuItem value='Harvester'>{t('reg.harvester')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    {harvesterOrDriver === "Driver" &&
                        <>
                        <Grid item xs={12} lg={6}>
                            <TextField fullWidth required error={errorMessage.pincodeError} helperText={errorMessage.pincodeError} type="number" onFocus={handleNumberFieldFocus} disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false} label={t('preReg.pincode')} name="driverPincode" value={driverDetail?.driverPincode} onChange={(e) => handleDriverChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                        </Grid>
                            <Grid item xs={12} lg={6}>
                                <TextField fullWidth required error={errorMessage.fullNameError} helperText={errorMessage.fullNameError} type="text" disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false} label={t('reg.fullName')} name="driverName" InputProps={{
                                    maxLength: maxNameLength
                                }} value={driverDetail?.driverName} onChange={(e) => handleDriverChange(e)} />
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <TextField required error={errorMessage.addressError} helperText={errorMessage.addressError} fullWidth disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false} type="textarea" multiline label={t('main.address')} name="driverAddress" value={driverDetail?.driverAddress} onChange={(e) => handleDriverChange(e)} inputProps={{
                                maxLength: 500
                            }} />
                        </Grid>
                            <Grid item xs={6} lg={3}>
                                <FormControl fullWidth>
                                    <InputLabel>{t('preReg.gender')}</InputLabel>
                                    <Select label={t('preReg.gender')} disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false} sname="driverGender" value={driverDetail?.driverGender} onChange={(e) => handleDriverChange(e)}>
                                        {GENDER.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} lg={3}>
                            <FormControl fullWidth error={errorMessage.driverDobError}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            label={t('reg.dob')}
                                            maxDate={subYears(new Date(), 18)}
                                            disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false}
                                            value={driverDetail.driverDob}
                                            onChange={(e) => handleDriverDobChange(e)}
                                        />
                                    </LocalizationProvider>
                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage.driverDobError}</FormHelperText>
                                     </FormControl>
                                {/* <TextField fullWidth required error={errorMessage.ageError} helperText={errorMessage.ageError} type="number" disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false} label="Age" name="driverAge" value={driverDetail?.driverAge} onChange={(e) => handleDriverChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} inputProps={{
                                                maxLength: 5
                                            }}/> */}
                        </Grid>
                            <Grid item xs={12} lg={6}>
                            <TextField fullWidth required error={errorMessage.drivingLicenseError} helperText={errorMessage.drivingLicenseError} type="text" label={t('reg.drivingLicenseNo')} name="driverLicenseId" value={driverDetail?.driverLicenseId} onChange={(e) => handleDriverChange(e)} maxLength={20} inputProps={{
                                maxLength: 20
                            }}></TextField>                          
                        </Grid>
                            <Grid item xs={12} lg={6}>
                                <TextField fullWidth required error={errorMessage.mobileNoError} helperText={errorMessage.mobileNoError} type="number" onFocus={handleNumberFieldFocus} disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false} label={t('reg.contactNo')} name="driverContactNo" value={driverDetail?.driverContactNo} onChange={(e) => handleDriverChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                            </Grid>                                              
                            <Grid item xs={12} lg={3}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                        disableFuture 
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            label={t('reg.licenseIssuedDate')}
                                            value={driverDetail.licenceIssueDate}
                                            onChange={(e) => handleDateChange(e, "licenceIssueDate")}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} lg={3}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            label={t('reg.validityEndDate')}
                                            value={driverDetail.licenceValidityEnddate}
                                             minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                            onChange={(e) => handleDateChange(e, "licenceValidityEnddate")}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                        </Grid>
                        <Grid item xs={12} lg={6}></Grid>
                        <Grid item xs={12} lg={6}>
                            <FileUploadMUI
                                documentList={documentsArray}
                                documentType="DrivingLicense"
                                callBackDocumentUpload={onUploadCallBack}
                                stakeholderDetailId={driverDetail.id}
                                title={t('reg.uploadDrivingLicenseDoc')}
                                stakeHolderType="hit"
                                disabled={(!ResourceUpdateMember.includes(userRole) || userRole === ROLES.ItAdmin) ? false : true}
                                errorMessage={errorMessage}
                                setErrorMessage={setErrorMessage}
                                documentError="dirivingLicenseError"
                            />
                            {/* <div className='mandatory_field'>{errorMessage.dirivingLicenseError}</div> */}
                        </Grid>
                            {/* <Grid item xs={12}>
                                <Typography>Driving Experience in</Typography>
                            </Grid>
                            <Grid item xs={6} lg={3}>
                                <FormControl fullWidth>
                                    <InputLabel>{t('reg.years')}</InputLabel>
                                    <Select label="Years" value={drivingExpInYrs} onChange={(e) => onChangeDrivingExpInYrs(e)}>
                                        {Array.from(Array(50), (e, i) => {
                                            return <MenuItem key={i} value={i}>{i}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} lg={3}>
                                <FormControl fullWidth>
                                    <InputLabel>{t('reg.months')}</InputLabel>
                                    <Select label="Months" value={drivingExpInMonths} onChange={(e) => onChangeDrivingExpInMonth(e)}>
                                        {NUMBER_OF_MONTH.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                    </Select>
                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage.experienceError}</FormHelperText>
                                </FormControl>
                            </Grid> */}
                        </>
                    }
                    {harvesterOrDriver === "Harvester" &&
                        <>
                        <Grid item xs={12} lg={6}>
                            <TextField fullWidth required error={errorMessage.harvesterPincodeError} helperText={errorMessage.harvesterPincodeError} type="number" onFocus={handleNumberFieldFocus} label={t('preReg.pincode')} name="harvesterPincode" disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false} value={harvesterDetail?.harvesterPincode} onChange={(e) => handleHarvesterChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                        </Grid>
                            <Grid item xs={12} lg={6}>
                                <TextField fullWidth required error={errorMessage.harvesterNameError} helperText={errorMessage.harvesterNameError} InputProps={{ maxLength: maxNameLength }} disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false} type="text" label={t('reg.fullName')} name="harvesterName" value={harvesterDetail?.harvesterName} onChange={(e) => handleHarvesterChange(e)} inputProps={{
                                                maxLength: maxNameLength
                                            }}/>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <TextField fullWidth required error={errorMessage.harvesterAddressError} helperText={errorMessage.harvesterAddressError} type="textarea" disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false} label={t('main.address')} name="harvesterAddress" value={harvesterDetail?.harvesterAddress} onChange={(e) => handleHarvesterChange(e)} multiline inputProps={{
                                maxLength: 500
                            }} />
                        </Grid>
                            <Grid item xs={6} lg={3}>
                                <FormControl fullWidth>
                                    <InputLabel>{t('preReg.gender')}</InputLabel>
                                    <Select fullWidth label={t('preReg.gender')} name="harvesterGender" disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false} value={harvesterDetail?.harvesterGender} onChange={(e) => handleHarvesterChange(e)}>
                                        {GENDER.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} lg={3}>
                            <FormControl fullWidth error={errorMessage.harvesterDobError}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            maxDate={subYears(new Date(), 18)}
                                            label={t('reg.dob')}
                                            disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false}
                                            value={harvesterDetail.harvesterDob}
                                            onChange={(e) => handleHarvesterDobChange(e)}
                                        />
                                    </LocalizationProvider>
                                    <FormHelperText sx={{ color: 'red' }}>{errorMessage.harvesterDobError}</FormHelperText>
                                     </FormControl>
                                {/* <TextField fullWidth required error={errorMessage.harvesterDobError} helperText={errorMessage.harvesterDobError} type="number" label="Age" name="harvesterAge" disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false} value={harvesterDetail?.harvesterAge} onChange={(e) => handleHarvesterChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} inputProps={{
                                                maxLength: 5
                                            }}/> */}
                        </Grid>

                        <Grid item xs={12} lg={6}>
                            <FormControl className='label_grower_reg' required>
                                <FormLabel>{t('reg.trainingCompleted')}</FormLabel>
                                <RadioGroup
                                    row
                                >
                                    <FormControlLabel control={<Radio name="isTrainingCompleted" disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false} checked={harvesterDetail?.isTrainingCompleted === true} onChange={(e) => radioChange(e, true)} />} label={t('preReg.yes')} />
                                    <FormControlLabel control={<Radio name="isTrainingCompleted" disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false} checked={harvesterDetail?.isTrainingCompleted === false} onChange={(e) => radioChange(e, false)} />} label={t('preReg.no')} />
                                </RadioGroup>
                            </FormControl>                         
                        </Grid>
                            <Grid item xs={12} lg={6}>
                                <TextField fullWidth required error={errorMessage.harvesterContactError} helperText={errorMessage.harvesterContactError} type="number" onFocus={handleNumberFieldFocus} label={t('reg.contactNo')} disabled={((props.addOrEdit === 'edit') && (ResourceUpdateMember.includes(userRole) && (userRole !== 'Reg-ITAdmin'))) ? true : false} name="harvesterContactNo" value={harvesterDetail?.harvesterContactNo} onChange={(e) => handleHarvesterChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                            </Grid>
                        <Grid item xs={12} lg={6}>
                            {harvesterDetail?.isTrainingCompleted === true &&
                                <FileUploadMUI key="Harvester_Training_Certificate"
                                    documentList={documentsArray}
                                    documentType="Harvester_Training_Certificate"
                                    callBackDocumentUpload={onUploadCallBack}
                                    stakeholderDetailId={driverDetail.id}
                                    title={t('reg.uploadTrainingCompletionDoc')}
                                    stakeHolderType="hit"
                                    disabled={(!ResourceUpdateMember.includes(userRole) || userRole === 'Reg-ITAdmin') ? false : true}
                                    errorMessage={errorMessage}
                                    setErrorMessage={setErrorMessage}
                                    documentError="trainingCertificateDocError"
                                />
                            }
                            {/* <div className='mandatory_field'>{errorMessage.trainingCertificateDocError}</div> */}
                        </Grid>
                   
                        </>}
                </Grid>
            </Container>
            <Box display='flex' alignItems="center" justifyContent="center" mt={3} mb={2} style={{ float: "right" }}>
                <Button sx={{ minWidth: 100 }}
                    variant="contained" onClick={props.onClose}>{t('reg.cancel')}</Button>
                <Button sx={{ minWidth: 100, ml: 1 }}
                    variant="contained" onClick={() => { harvesterOrDriver === "Driver" ? onCheckValidation() : onCheckValidationHarvester() }}>{props.addOrEdit === 'add' ? t('reg.add') : t('reg.update')}</Button>
            </Box>

        </>
    );
};
